<template>
  <div>
    <MasterDetail
      formTitle="Cadastro de Participantes (ICT)"
      :cols="cols"
      :opts="opts"
      :customResource="customResource"
      descriptionProperty="nome"
      :hasExportCSV="false"
      :hasExportXLSX="false"
      serverPagination
      cancelButtonTextOnly
    >
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div class="table-v-action-button mr-3" v-bind="attrs" v-on="on">
            <v-icon>mdi-file-delimited-outline</v-icon>
            Exportações
          </div>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title class="table-v-action-button" @click="exportCsv()">
              <v-icon>mdi-file-delimited</v-icon>
              XLSX Assíncrono
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </MasterDetail>
    <v-dialog v-model="exportacaoAsyncDialog" scrollable persistent max-width="400">
      <v-card>
        <v-card-title style="display: block" class="pb-1">
          <v-icon x-large class="mr-3">mdi-file-delimited-outline</v-icon>
          Exportar Relatório
          <v-btn @click="exportacaoAsyncDialog = false" style="position: absolute; right: 5px; top: 5px" icon>
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p>Requisição entrou na fila para processamento.</p>
          <p>Para ver o progresso e baixar o relatório, veja a fila.</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-6 pb-3 pt-0">
          <v-spacer></v-spacer>
          <v-btn color="primary" class="pr-5" dark depressed @click="exportacaoAsyncDialog = false">
            <v-icon left>mdi-chevron-left</v-icon> Fechar
          </v-btn>
          <v-btn color="primary" dark depressed class="px-5 ml-3" @click="verFila()">
            Ver fila
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MasterDetail from "@/components/master-detail.vue";
import ictParticipantesService from "@/api/ict/ictParticipantes.service";
import ictUsuariosService from "@/api/ict/ictUsuarios.service";
import { ESCOLARIDADES } from "@/templates/ict/ict.constants";

export default {
  name: "IctParticipantes",
  components: {
    MasterDetail,
  },
  computed: {
    empresaId() {
      return this.$store.getters.clientId;
    },
    customResource() {
      const empresaId = this.empresaId;
      return {
        get: (params) => ictParticipantesService.getAll(empresaId, params),
        save: (data, id) => {
          const promise = id
            ? ictParticipantesService.update(empresaId, id, data)
            : ictParticipantesService.create(empresaId, data);
          return promise.catch(e => ({ error: e.response?.data?.message || "Falha ao salvar participante." }));
        },
        delete: (id) => {
          return ictParticipantesService.delete(empresaId, id)
            .catch(e => {
              const errors = e.response?.data?.errors;
              const errorMsg = errors
                ? Object.values(errors).flat().join(" ")
                : (e.response?.data?.error || e.response?.data?.message || "Falha ao excluir participante.");
              this.$notify({
                group: "geral",
                duration: 5000,
                type: "error",
                title: "Erro",
                text: errorMsg
              });
            });
        },
      };
    },
  },
  data() {
    return {
      exportacaoAsyncDialog: false,
      cols: [
        {
          key: "id",
          name: "ID",
          hideInform: true,
        },
        {
          key: "nome",
          name: "Nome Completo",
          type: this.$fieldTypes.TEXT,
          colSize: 12,
          rules: [{ rule: "required" }],
          filterable: true,
        },
        {
          key: "cpf",
          name: "CPF",
          type: this.$fieldTypes.CPF,
          colSize: 12,
          rules: [{ rule: "required" }],
          filterable: true,
        },
        {
          key: "escolaridade",
          name: "Escolaridade",
          type: this.$fieldTypes.SELECT,
          colSize: 12,
          rules: [{ rule: "required" }],
          filterable: true,
          rel: { to: "escolaridades", key: "id", name: "name" },
        },
        {
          key: "usuario_id",
          name: "Usuário de Sistema (opcional)",
          type: this.$fieldTypes.AUTOCOMPLETE,
          rel: { to: "usuarios", key: "id", name: "label" },
          colSize: 12,
          hint: "Vincule este participante a um usuário para puxar as horas lançadas no timesheet.",
        },
        {
          key: "criado_em",
          name: "Criado Em",
          type: this.$fieldTypes.DATETIME,
          hideInform: true,
        },
      ],
      opts: {
        escolaridades: ESCOLARIDADES,
        usuarios: [],
      },
    };
  },
  watch: {
    empresaId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadUsuarios();
        }
      },
    },
  },
  methods: {
    async loadUsuarios() {
      try {
        const list = await ictUsuariosService.selecao(this.empresaId);
        this.opts.usuarios = (list || []).map(u => ({
          id: u.id,
          label: `${u.usuario} — ${u.nome}`,
        }));
      } catch (e) {
        console.error("Erro ao carregar usuários", e);
      }
    },
    confirmDeleteMessage({ nome }) {
      return `Deseja realmente deletar o participantes <b>"${nome}"</b>?`;
    },
    exportCsv: function () {
      const md = this.$children.find(c => c.$options.name === 'MasterDetail');
      const filters = md ? md.pageTableFilters : {};

      this.apiResource(`v1/clientes/${this.empresaId}/exportacao`)
        .save({
          tipoRelatorio: "ict-participantes",
          filters: JSON.stringify(filters)
        })
        .then(() => {
          this.exportacaoAsyncDialog = true;
        });
    },
    verFila: function () {
      this.$router.push({
        path: "/clientes/dashboard/relatorios-exportados",
      });
    },
  },
};
</script>
